import { getCrmSettings, updateCrmSettings } from "@/api/crm";
import { addToast } from "@/store/app/action.js";

// Load CRM settings from API
export const loadCrmSettings = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: "CRM_SETTINGS_LOADING" });
      
      const response = await getCrmSettings();
      
      if (response.status === "success") {
        dispatch({ type: "CRM_SETTINGS_LOADED", payload: response.data });
      } else {
        throw new Error(response.message || "Failed to load CRM settings");
      }
    } catch (error) {
    }
  };
};

// Save CRM settings to API
export const saveCrmSettings = (settings) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "CRM_SETTINGS_SAVING" });
      
      const response = await updateCrmSettings(settings);
      
      if (response.status === "success") {
        dispatch({ type: "CRM_SETTINGS_SAVED", payload: response.data });
        
        // Show success toast
        dispatch(
          addToast({
            type: "success",
            message: "CRM settings updated successfully",
            timer: 5,
          })
        );
        
        return response;
      } else {
        throw new Error(response.message || "Failed to update CRM settings");
      }
    } catch (error) {     
      // Extract error message from the response if available
      let errorMessage = "Error updating CRM settings. Please try again.";
      
      if (error.response && error.response.data) {
        // If error has response data with message
        errorMessage = error.response.data.message || errorMessage;
      } else if (error.message) {
        // If error has a message property
        errorMessage = error.message;
      }
      
      dispatch({ type: "CRM_SETTINGS_SAVE_ERROR", payload: errorMessage });
      
      // Show error toast with the specific error message
      dispatch(
        addToast({
          type: "error",
          message: errorMessage,
        })
      );
      
      throw error;
    }
  };
};

// Update domains array
export const updateDomains = (domains) => {
  return { type: "CRM_SETTINGS_UPDATE_DOMAINS", payload: domains };
};

// Add a new domain
export const addDomain = (domainName) => {
  return { type: "CRM_SETTINGS_ADD_DOMAIN", payload: domainName };
};

// Remove a domain
export const removeDomain = (domainName) => {
  return { type: "CRM_SETTINGS_REMOVE_DOMAIN", payload: domainName };
};

// Update a specific field
export const updateField = (field, value) => {
  return { type: "CRM_SETTINGS_UPDATE_FIELD", payload: { field, value } };
};

// Set header editor modal open/closed
export const setHeaderEditorOpen = (isOpen) => {
  return { type: "CRM_SETTINGS_SET_HEADER_EDITOR_OPEN", payload: isOpen };
};

// Set instructions modal open/closed
export const setInstructionsModalOpen = (isOpen) => {
  return { type: "CRM_SETTINGS_SET_INSTRUCTIONS_MODAL_OPEN", payload: isOpen };
};

// Set warning modal open/closed
export const setWarningModalOpen = (isOpen) => {
  return { type: "CRM_SETTINGS_SET_WARNING_MODAL_OPEN", payload: isOpen };
};

// Set selected domain for instructions
export const setSelectedDomain = (domain) => {
  return { type: "CRM_SETTINGS_SET_SELECTED_DOMAIN", payload: domain };
};

// Reset dirty state
export const resetDirty = () => {
  return { type: "CRM_SETTINGS_RESET_DIRTY" };
};

// Reset to original values
export const resetToOriginal = () => {
  return { type: "CRM_SETTINGS_RESET_TO_ORIGINAL" };
}; 